import { Dispatch, SetStateAction, useCallback, useState } from "react";

export default function useLocalStorage<T>(key: string, initialValue?: T | (() => T)): [T, Dispatch<SetStateAction<T>>] {
    const [state, setState] = useState<T>(() => {
        const item = localStorage.getItem(key);
        if (item !== null) {
            return JSON.parse(item);
        }
        else if (initialValue instanceof Function) {
            return initialValue();
        }
        else {
            return initialValue;
        }
    });

    const handleSetState = useCallback<Dispatch<SetStateAction<T>>>(value => {
        setState(prev => {
            const next = value instanceof Function ? value(prev) : value;
            if (next === undefined) {
                localStorage.removeItem(key);
            }
            else {
                localStorage.setItem(key, JSON.stringify(next));
            }
            return next;
        });
    }, [key, setState]);

    return [state, handleSetState];
}